
/**
 * Storage for user messages.
 */

import React, { useReducer, createContext } from "react";

export const MessageContext = createContext();

const initialState = {
  display: false,
  type:'ok',
  title: 'error message',
  message:'This is your error message',
};


const reducer = (state, action) => {
  switch (action.type) {
    case "set":
      return { ...state, 
        display: action.payload.display,
        type: action.payload.type,
        title:action.payload.title,
        message: action.payload.message,
      };
    case "end":
        return { ...state, 
            display: false
        };
      
    default:
      throw new Error();
  }
};

export const MessageContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <MessageContext.Provider value={[state, dispatch]}>
      {props.children}
    </MessageContext.Provider>
  );
};